import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Image } from "antd";
import { API_BASE } from "../../utils/contrains";
// import { formateDate } from "../../utils/dateUtil";

import "./student-apply-detail-modal.css";
class StudentApplyDetailModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    scholarship: PropTypes.object.isRequired,
  };

  handlePrint = () => {
   // console.log(this.props.scholarship);

    // 取得要列印的 DOM 節點
    const elem1 = document.getElementById("printThis1");
    const elem2 = document.getElementById("printThis2");

    // 克隆 DOM 節點
    const domClone1 = elem1.cloneNode(true);
    const domClone2 = elem2.cloneNode(true);

    // 建立列印專用區域
    const printSection = document.createElement("div");
    printSection.id = "printSection";
    printSection.style.position = "absolute";
    printSection.style.top = "0";
    printSection.style.left = "0";
    printSection.style.width = "100%";
    printSection.style.zIndex = "-1"; // 避免干擾畫面
    printSection.style.visibility = "hidden"; // 隱藏列印節點

    // 將克隆內容附加到列印區域
    printSection.appendChild(domClone1);
    const pageBreak = document.createElement("div");
    // pageBreak.style.pageBreakAfter = "always"; // 強制分頁
    printSection.appendChild(pageBreak);
    printSection.appendChild(domClone2);

    // 插入到 body 中
    document.body.appendChild(printSection);

    // 呼叫瀏覽器列印
    window.print();

    // 列印完成後清理列印區域
    document.body.removeChild(printSection);
  };

  render() {
    //console.log(this.props.scholarship);
    const {
      FormCode,
      AuditDescription,
      DivisionTwName,
      EducationalSystemTwName,
      ClassroomTwName,
      ApplicantTwName,
      ApplicantId,
      Cellphone,
      EMail,
      // StudentCardFrontFileUrl,
      // StudentCardBackFileUrl,
      EnrollmentLetterFileUrl,
      AlumniTwName,
      AlumniCategory,
      AlumniRelation,
      AlumniId,
      MembershipFileUrl,
      RelationFileUrl,
      DiplomaFileUrl,
      ReviewerName,
    } = this.props.scholarship;
    return (
      <>
        <button onClick={this.handlePrint} className="btn btn-danger btn-sm">
          <i className="fa fa-print"></i> 列印{" "}
        </button>
        <p></p>
        <div id="printThis1">
          <table width="100%" border="1">
            <tr>
              <td
                height="29"
                colspan="6"
                bgcolor="#CCCCCC"
                align="center"
                style={{ fontSize: "1.5em" }}
              >
                校友家族獎學金申請表
              </td>
            </tr>
            <tr>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                申請案號
              </td>
              <td colspan="5">&nbsp;{FormCode}</td>
            </tr>
            <tr>
              <td
                width="84"
                rowspan="2"
                align="center"
                valign="middle"
                bgcolor="#CCCCCC"
              >
                審核程序
              </td>
              <td width="106" align="center" valign="middle" bgcolor="#CCCCCC">
                承辦人
              </td>
              <td colspan="4">&nbsp;{ReviewerName}</td>
            </tr>
            <tr>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                資格審查結果
              </td>
              <td colspan="4">&nbsp;{AuditDescription}</td>
            </tr>
            <tr>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                就讀學制
              </td>
              <td>
                &nbsp;{DivisionTwName}/{EducationalSystemTwName}
              </td>
              <td width="112" align="center" valign="middle" bgcolor="#CCCCCC">
                班級
              </td>
              <td width="142">&nbsp;{ClassroomTwName}</td>
              <td width="80" align="center" valign="middle" bgcolor="#CCCCCC">
                學號
              </td>
              <td width="116">&nbsp;{ApplicantId}</td>
            </tr>
            <tr>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                申請人姓名
              </td>
              <td>&nbsp;{ApplicantTwName}</td>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                手機
              </td>
              <td>&nbsp;{Cellphone}</td>
              <td align="center" valign="middle" bgcolor="#CCCCCC">
                E-MAIL
              </td>
              <td valign="middle">
                &nbsp;<span style={{ fontSize: "0.8em" }}>{EMail}</span>
              </td>
            </tr>
            <tr>
              <td colspan="6" align="center" valign="middle" bgcolor="#CCCCCC">
                在學證明
              </td>
            </tr>
            <tr>
              <td colspan="6" align="center" valign="middle">
                <Image
                  width={380}
                  height={490}
                  src={API_BASE + EnrollmentLetterFileUrl}
                />
              </td>
            </tr>
          </table>
        </div>
        <div id="printThis2">
          <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
              <td width="70" align="center" valign="middle" bgcolor="#CCCCCC">
                身分證字號
              </td>
              <td width="100">&nbsp;{AlumniId}</td>
              <td width="70" align="center" valign="middle" bgcolor="#CCCCCC">
                校友姓名
              </td>
              <td width="100">&nbsp;{AlumniTwName}</td>
              <td width="70" align="center" valign="middle" bgcolor="#CCCCCC">
                申請類別
              </td>
              <td width="100">
                &nbsp;{AlumniCategory}/{AlumniRelation}
              </td>
            </tr>
            <tr>
              <td colspan="2" align="center" valign="middle" bgcolor="#CCCCCC">
                畢業證書
              </td>
              <td colspan="2" align="center" valign="middle" bgcolor="#CCCCCC">
                入會證明
              </td>
              <td colspan="2" align="center" valign="middle" bgcolor="#CCCCCC">
                與校友關係證明
              </td>
            </tr>
            <tr>
              <td height="280" colspan="2" align="center" valign="middle">
                <Image
                  width={240}
                  height={350}
                  src={API_BASE + DiplomaFileUrl}
                />
              </td>
              <td colspan="2" align="center" valign="middle">
                {" "}
                <Image
                  width={240}
                  height={350}
                  src={API_BASE + MembershipFileUrl}
                />
              </td>
              <td colspan="2" align="center" valign="middle">
                {" "}
                {AlumniCategory !== "本人" ? (
                  <Image
                    width={240}
                    height={350}
                    src={API_BASE + RelationFileUrl}
                  />
                ) : (
                  "略(本人)"
                )}
              </td>
            </tr>
          </table>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentApplyDetailModal);
